import { Component, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../../../core/animations';

/**Local files */
import { displayValues, apiCalls, toastMsg } from '../../../../../../../utils/index';

/**Service file */

import { SideNavService } from '../../../../sidenav.service';

/**Local component */

import { ToastComponent } from '../../../../../../../common/toast.component';

@Component({
    selector: 'side-details',
    templateUrl: './sideNav.component.html',
    styleUrls: ['./sideNav.component.scss'],
    animations: fuseAnimations
})

export class SideNavComponent {

    @ViewChild('downloadZipLink') private downloadZipLink: ElementRef;

    displayValues = displayValues;
    apiCalls = apiCalls;
    toastMsg = toastMsg;

    selected: any;
    userId: string;
    userName: string;

    onProInfoSelectedSubscription: Subscription;

    constructor(

        /** Local component */
        public toastComponent: ToastComponent,

        /** Service file */
        public sideNavService: SideNavService
    ) {

    }

    ngOnInit() {

        this.onProInfoSelectedSubscription =
            this.sideNavService.onProInfoSelected.subscribe(selected => {

                this.selected = selected[0];
                this.userId = selected[1];
                this.userName = selected[2];
            });
    }

    ngOnDestroy() {
        this.onProInfoSelectedSubscription.unsubscribe();

    }

    openFile(parameter) {

        // If document exist
        if (this.selected && this.selected[parameter] != undefined) {

            var link = this.apiCalls.uploadStartUrl + this.userId + '/';
            link = link + parameter + '/' + this.selected[parameter];
            window.open(link, '_blank');


        } else { // If document not exist
            this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
        }

    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/review/side-nav/sideNav.component.ts